import styled, { css } from 'styled-components';

export const TBody = styled.tbody`
    justify-content: center;
    align-items: center;
    height: 100%;
    border-collapse: collapse;
`;
